export const ENTITY_CONST = {
  eventType: {
    name: `Тип события`,
    create: {
      url: () => `/events/types`,
      method: `post`,
    },
    update: {
      url: id => `/events/types/${id}`,
      method: `put`,
    },
    messages: {
      create: name => `Тип событий "${name}" успешно создан.`,
      update: name => `Тип событий "${name}" успешно отредактирован.`,
    },
  },
}
